import { useEffect } from "react";
import { api } from "../lib/api";
import { Hero } from "../components/home/Hero";
import { Marquee } from "../components/common/Marquee";
import { ThreeWays } from "../components/home/ThreeWays";
import { PickYourFun } from "../components/home/PickYourFun";
import { FlavorStage } from "../components/home/FlavorStage";
import { Experiences } from "../components/home/Experiences";
import { ShopPreview } from "../components/home/ShopPreview";
import { PartyReady } from "../components/home/PartyReady";
import { Wholesale } from "../components/home/Wholesale";
import { Moments } from "../components/home/Moments";
import { ComingSoon } from "../components/home/ComingSoon";
import { GuestList } from "../components/home/GuestList";

export const HomePage = () => {
    useEffect(() => {
        document.title = "Showtime Carnival Co. — Cotton Candy & Popcorn Catering NYC | Bring The Show.";
        api.get("/settings/public").then((res) => {
            const seo = res.data?.seo;
            if (seo?.site_title) document.title = seo.site_title;
            if (seo?.meta_description) {
                const desc = document.querySelector('meta[name="description"]');
                if (desc) desc.setAttribute("content", seo.meta_description);
            }
        }).catch(() => {});
    }, []);

    return (
        <>
            <Hero />
            <Marquee />
            <ThreeWays />
            <PickYourFun />
            <FlavorStage />
            <Experiences />
            <ShopPreview />
            <PartyReady />
            <Wholesale />
            <Moments />
            <ComingSoon />
            <Marquee inverted />
            <GuestList />
        </>
    );
};
